import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
 
} from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs, { Dayjs } from 'dayjs';


const getShoptime = (time) => {
         
    // console.log("#########");
 
     // LT	h:mm A	8:02 PM
     // LTS	h:mm:ss A	8:02:18 PM
     // L	MM/DD/YYYY	08/16/2018
     // LL	MMMM D, YYYY	August 16, 2018
     // LLL	MMMM D, YYYY h:mm A	August 16, 2018 8:02 PM
     // LLLL	dddd, MMMM D, YYYY h:mm A	Thursday, August 16, 2018 8:02 PM
     // l	M/D/YYYY	8/16/2018
     // ll	MMM D, YYYY	Aug 16, 2018
     // lll	MMM D, YYYY h:mm A	Aug 16, 2018 8:02 PM
     // llll	ddd, MMM D, YYYY h:mm A	Thu, Aug 16, 2018 8:02 PM
     
    
    

     const tm=dayjs(time).format('LT');
   
    // console.log(time)
     //console.log("#########");
     return tm;
 }



const ShopTimingCard = ({current}) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif',
 
        padding: '0px',
       margin: '0px'
      }
   


    return(
        <>
        <hr/>
            <List className='timingInfoCard'>

          
                

                
                <div>   

                { current.timmimg.length>>0 ?
                    <div className='mt-3 content'>

                { current.timmimg.map(item=>(
                       
                   
                                            
                           <div>
              <Divider variant='inset' component="li"/>
              <ListItem>
                    
                    <ListItemAvatar>
                        <Avatar><AccessTimeIcon/></Avatar>
                        </ListItemAvatar>
                        <ListItemText style={listStyles} primary="Timings" />
                
                    
                  </ListItem>
                

               
                
                  
                
                    <ListItem>
                    
                    <ListItemText style={listStyles} primary="Open" />
                   
                    </ListItem>
                    <ListItem>
                <ListItemText style={listStyles} primary={getShoptime(item.openFrom)+" To "+getShoptime(item.openTo)} />
               
                </ListItem>


               
                    <ListItem>
                    
                    <ListItemText style={listStyles} primary="Break" />
                   
                    </ListItem>
                    <ListItem>
                <ListItemText style={listStyles} primary={getShoptime(item.brkFrom)+" To "+getShoptime(item.brkTo)} />
             
                </ListItem>


                <ListItem>
                <ListItemText style={listStyles} primary={item.remark} />
                </ListItem>
                
              
                <ListItem>
                
                <ListItemText style={listStyles} primary="weekStatus" secondary={item.weekStatus} />
                <ListItemText style={listStyles} primary="timeStatus" secondary={item.timeStatus} />
                <ListItemText style={listStyles} primary="brkStatus" secondary={item.brkStatus} />
                </ListItem>
               
                
                            </div>                 
                               
                     
                                        
                                            
                        ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 

               
            </List>
           

        </>
    )
}

export default ShopTimingCard